import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { SearchMetadata, SearchPageState } from '../Search.model';

export const selectSearchPageState = (
  state: SpartacuxProductDiscoveryDomainState,
): SearchPageState | undefined => state.productDiscovery?.searchPage;

const defaultValue: SearchMetadata = { breadcrumb: [] };

export const selectSearchPageMetadata = (
  state: SpartacuxProductDiscoveryDomainState,
) => selectSearchPageState(state)?.metadata || defaultValue;
